import { render, staticRenderFns } from "./TheCustomerRetention.vue?vue&type=template&id=2701e8df&"
import script from "./TheCustomerRetention.vue?vue&type=script&lang=js&"
export * from "./TheCustomerRetention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports